// @ts-nocheck
if (!window.videoObserver) {
  const unblur = (video) => video.classList.remove('blur-sm')

  // Swap the tiny blurred placeholder for the sharp poster (data-poster), if the video has one,
  // and unblur once that image has downloaded so the placeholder is never shown sharp-edged
  function showPoster(video) {
    const src = video.dataset.poster
    if (!src) return
    delete video.dataset.poster
    const img = new Image()
    img.onload = () => {
      video.poster = src
      unblur(video)
    }
    img.src = src
  }

  function loadVideo(video) {
    showPoster(video)
    let source = video.querySelector('source')
    if (!source) {
      // A paused video keeps showing its poster even after loadeddata, so only unblur once a real
      // frame replaces it (playback or a seek), unless the sharp poster got there first
      video.addEventListener('playing', () => unblur(video), { once: true })
      video.addEventListener('seeked', () => unblur(video), { once: true })
      const srcs = JSON.parse(video.getAttribute('data-srcs') || '[]')
      srcs.forEach((src) => {
        source = document.createElement('source')
        source.setAttribute('type', src.type)
        source.setAttribute('src', src.src)
        video.appendChild(source)
      })
    }
  }

  // For gallery slides that aren't showing: attach sources without autoplaying, and buffer the opening
  // now if `now`, otherwise after window load so it doesn't compete with the page's own requests
  // ('metadata' still buffers 1-2MB per video in Chrome, 'none' fetches nothing)
  function prefetchVideo(video, now) {
    if (!video.dataset.prefetched) {
      video.dataset.prefetched = 'true'
      video.autoplay = false
      if (!now && document.readyState !== 'complete') {
        video.preload = 'none'
        window.addEventListener('load', () => (video.preload = 'metadata'), { once: true })
      } else {
        video.preload = 'metadata'
      }
      loadVideo(video)
    } else if (now) {
      video.preload = 'metadata'
    }
  }

  // Load a gallery's videos gradually around the active slide, called again whenever it changes:
  // 0 slides away loads (the gallery plays it), 1 away buffers its opening, 2 away only gets its sharp poster.
  // Neighbours buffer now if the active slide isn't a video, otherwise after window load.
  window.prefetchGalleryVideos = (slides, index) => {
    const now = !slides[index]?.querySelector('video')
    slides.forEach((slide, i) => {
      const video = slide.querySelector('video[data-lazy-video]')
      const distance = Math.abs(i - index)
      if (!video || distance > 2) return
      if (distance === 0) loadVideo(video)
      else if (distance === 1) prefetchVideo(video, now)
      else showPoster(video)
    })
  }

  window.videoObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio < 0.5 && !entry.target.paused) {
          entry.target.pause()
        } else if (entry.intersectionRatio >= 0.5 && entry.target.paused) {
          loadVideo(entry.target)
          const $splideSlide = entry.target.closest('.splide__slide')
          if ($splideSlide) {
            // If it's in a splide slide, pause because we have splide events handling play/pause
            entry.target.pause()
          } else {
            entry.target.play()
          }

          // GA tracking for video play
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            event: 'videoPlay',
            videoName:
              entry.target.getAttribute('alt') ||
              [...entry.target.querySelectorAll('source')]?.at(-1)?.getAttribute('src') ||
              'Unnamed video',
          })
        }
      })
    },
    { threshold: [0.1, 0.25, 0.5, 0.75, 0.9] }
  )

  // Load as a video approaches the viewport: the sharp poster about 1.5 screens away, sources (so it starts
  // buffering) half a screen away. Slides clipped by a slider's overflow don't count until they're shown.
  const whenNear = (rootMargin, onNear) =>
    new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return
          observer.unobserve(entry.target)
          onNear(entry.target)
        })
      },
      { rootMargin }
    )
  const posterObserver = whenNear('150% 0px', showPoster)
  const loadObserver = whenNear('50% 0px', loadVideo)

  const $$videos = document.querySelectorAll('[data-lazy-video]')
  $$videos.forEach(($video) => {
    posterObserver.observe($video)
    loadObserver.observe($video)
    // Videos rendered without autoplay are played by their section (e.g. sliders), so don't pause them here
    if ($video.hasAttribute('autoplay')) window.videoObserver.observe($video)
    $video.loadVideo = () => loadVideo($video)
  })
}
